import { create } from 'zustand'

import { initialAssetTypeState } from './slices/assetType'
import { initialDatePublishedState } from './slices/datePublished'
import { initialDesignersState } from './slices/designers'
import { initialFileTypesState } from './slices/fileTypes'
import { initialLicensesState } from './slices/licenses'
import { initialMoreFiltersState } from './slices/moreFilters'
import { initialPolygonState } from './slices/polygon'
import { initialPricingState } from './slices/pricing'
import { initialQualityContentState } from './slices/qualityContent'
import { initialSortByState } from './slices/sortBy'
import { initialStylesState } from './slices/styles'
import { initialTagsState } from './slices/tags'
import { initialThreeDOnlyState } from './slices/threeDOnly'
import { initialThreeDPrintOnlyState } from './slices/threeDPrintOnly'

const initialState = {
  ...initialAssetTypeState,
  ...initialDatePublishedState,
  ...initialDesignersState,
  ...initialFileTypesState,
  ...initialLicensesState,
  ...initialMoreFiltersState,
  ...initialPolygonState,
  ...initialPricingState,
  ...initialQualityContentState,
  ...initialSortByState,
  ...initialStylesState,
  ...initialTagsState,
  ...initialThreeDOnlyState,
  ...initialThreeDPrintOnlyState,
}

export const useSearchPageStore = create(() => initialState)

export const searchPageStore = useSearchPageStore
